import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { cfg } from './config/runtimeConfig'
import './styles/tokens.css'
import './styles/base.css'
import './styles/entity.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* REACT_APP_ROUTER_BASENAME when the app is served from a sub-folder */}
    <BrowserRouter basename={cfg('REACT_APP_ROUTER_BASENAME') || ''}>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
